import { render, staticRenderFns } from "./ComboboxTemasByEixo.vue?vue&type=template&id=a25590f2"
import script from "./ComboboxTemasByEixo.vue?vue&type=script&lang=js"
export * from "./ComboboxTemasByEixo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports